import * as React from "react";

const LinkPrintInactive: React.FC = () => (
    <svg
        width="12px"
        height="12px"
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="currentColor"
            d="M2.625,3.75 L2.625,1.125 L8.53359389,1.125 L9.375,1.96640611 L9.375,3.75 L10.5,3.75 L10.5,1.5 L9,0 L2.625,0 L1.5,0 L1.5,1.125 L1.5,3.75 L2.625,3.75 Z M9,8.625 L9,10.875 L3,10.875 L3,8.625 L9,8.625 Z M3,7.5 L1.875,7.5 L1.875,8.25 L1.125,8.25 L1.125,5.625 L10.875,5.625 L10.875,8.25 L10.125,8.25 L10.125,7.5 L9,7.5 L3,7.5 Z M10.125,9.375 L10.875,9.375 L12,9.375 L12,8.25 L12,5.625 L12,4.5 L10.875,4.5 L1.125,4.5 L0,4.5 L0,5.625 L0,8.25 L0,9.375 L1.125,9.375 L1.875,9.375 L1.875,10.875 L1.875,12 L3,12 L9,12 L10.125,12 L10.125,10.875 L10.125,9.375 Z"
            opacity=".5"
        />
    </svg>
);

export default React.memo(LinkPrintInactive);
